import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import apiFetch from 'utils/apiFetch';
import { sessionService } from 'redux-react-session';
import Loading from 'components/LoadingComponent';
import { ImpersonateWrapper } from './styles';

function Impersonate(props) {
  const { match: { params: { hash } } } = props;

  const [error, setError] = useState(null);

  useEffect(() => {
    apiFetch('POST', { endPoint: `/impersonate/${hash}` })
      .then((response) => {
        sessionService.saveSession({ token: response.user_code })
          .then(() => {
            const user = Object.assign({}, response);
            user.instance = response.instance_id;
            sessionService.saveUser(user)
              .then(() => {
                window.sendUserIdentifier(user.id);
                window.location.href = window.location.origin;
              });
          });
      })
      .catch((responseError) => {
        setError(responseError.response.data.error);
      });
  }, []);

  if (error) {
    return (
      <ImpersonateWrapper>
        <div className='error_msg'>{error}</div>
      </ImpersonateWrapper>
    );
  }

  return (
    <ImpersonateWrapper>
      <Loading colorAnimation='#888888' />
    </ImpersonateWrapper>
  );
}

Impersonate.propTypes = {
  match: PropTypes.object.isRequired,
};

export default Impersonate;



// WEBPACK FOOTER //
// ./src/routes/Impersonate/components/index.jsx